'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _categoryForm = require('./category-form.html');

var _categoryForm2 = _interopRequireDefault(_categoryForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _categoryForm2.default,
  bindings: {
    category: '<',
    dialogTitle: '@',
    submitTitle: '@',
    categoryChanged: '&'
  },
  controller: function () {
    function CategoryFormComponent(EventEmitter) {
      'ngInject';

      _classCallCheck(this, CategoryFormComponent);

      Object.assign(this, { EventEmitter: EventEmitter });
    }

    _createClass(CategoryFormComponent, [{
      key: 'onSubmit',
      value: function onSubmit() {
        this.categoryChanged(this.EventEmitter({
          category: this.category
        }));
      }
    }]);

    return CategoryFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/app/admin/categories/category-form/category-form.component.js